import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('token') || null,
    role: localStorage.getItem('role') || null,
    loading: false,
    error: null,
  },
  reducers: {
    loginRequest: (state) => { state.loading = true; state.error = null; },
    loginSuccess: (state, action) => {
      state.loading = false; 
      state.token = action.payload.token; 
      state.role = action.payload.role;
    },
    loginFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    
    registerRequest: (state) => { state.loading = true; state.error = null; },
    registerSuccess: (state) => { state.loading = false; state.error = null; },
    registerFailure: (state, action) => { state.loading = false; state.error = action.payload; },

    logout: (state) => { 
        state.token = null; 
        state.role = null; 
        localStorage.clear(); 
    }
  }
});

export const { loginRequest, loginSuccess, loginFailure, registerRequest, registerSuccess, registerFailure, logout } = authSlice.actions;
export default authSlice.reducer;